// src/components/ExportTransfer/Uploader.js
import Button from 'components/Button';
import Control from 'components/Control/Control';
import Flex from 'components/Flex';
import UploadIcon from 'components/icons/UploadIcon';
import React, { Fragment } from 'react';
import ErrorMessage from 'utils/ErrorMessage';
import {
  AddIcon,
  SmallButtons,
  SpanText,
  StyledH2,
  StyledUpload,
  TextWrapper,
  UploadText,
  Wrapper,
} from 'components/Uploader/Styles';
import Add from 'components/icons/Add';
import { deleteFile, uploadFile } from 'modules/Drive/actions';
import { useDispatch } from 'react-redux';

const Uploader = ({
  isDelete,
  file,
  setFile,
  isDefault = false,
  showTextUploder,
  showButtonUpLoader,
  fileName,
  format = 'pdf, docs and xlsx',
  setFileURL,
  message,
  isWhiteDesign,
  customHeight,
  setIsPreviewJD,
  handleFileChange,
  showButtonType,
  multiple = true,
  pointerEventDisable,
  disabled = false,
  notAllowedCursor = false,
  skipInternalUpload = false,
  compactMode = false,
}) => {
  const dispatch = useDispatch();

  const allowedFormats = '.xlsx,.csv,.pdf,.zip,.docx,.doc,.ppt,.pptx';

  const getFileUrl = async info => {
    let getType = info?.file?.type?.includes('xlsx') ? 'xlsx' : info?.file?.type?.includes('csv') ? 'csv' : info?.file?.type?.includes('pdf') ? 'pdf' : info?.file?.type?.includes('zip') ? 'zip' : info?.file?.type?.includes('docx') ? 'docx' : info?.file?.type?.includes('doc') ? 'doc' : info?.file?.type?.includes('ppt') ? 'ppt' : info?.file?.type?.includes('pptx') ? 'pptx' : '';
    let name = fileName + '.' + getType;
    let response = await dispatch(uploadFile(info?.file?.originFileObj, name));
    if (response) {
      setFile(response);
    }
  };

  const props = {
    name: 'file',
    multiple: false,
    listType: 'picture',
    accept: allowedFormats,
    beforeUpload: file => {
      const isLt25mb = file.size / 1024 / 1024 <= 25;
      const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
      const isValidFormat = allowedFormats.split(',').some(format => format.trim() === fileExtension);
      
      if (!isLt25mb) {
        ErrorMessage('File must be smaller than 25MB!');
        return false;
      } else if (!isValidFormat) {
        ErrorMessage('File should be in xlsx/csv/pdf/zip/docx/doc/ppt/pptx format!');
        return false;
      }
    },
    onChange: async info => {
      if (isDelete && info?.file?.status === 'done') {
        let response = await dispatch(deleteFile(file));
        if (response) {
          return getFileUrl(info);
        }
      } else if (!isDelete && info?.file?.status === 'done') {
        return getFileUrl(info);
      }
    },
    itemRender: () => {},
  };

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('OK');
    }, 0);
  };

  const onBeforeUpload = file => {
    const isLt25mb = file.size / 1024 / 1024 <= 25;
    const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
    const isValidFormat = allowedFormats.split(',').some(format => format.trim() === fileExtension);

    if (!isLt25mb) {
      ErrorMessage('File must be smaller than 25MB!');
      return false;
    } else if (!isValidFormat) {
      ErrorMessage('File should be in xlsx/csv/pdf/zip/docx/doc/ppt/pptx format!');
      return false;
    }
    return true;
  };

  const onChangeFileUpload = async info => {
    if (info?.file?.status === 'done') {
      const originFile = info?.file?.originFileObj;
      const fileExtension = originFile.name.split('.').pop();
      let getType = originFile.type || fileExtension;
      let name = info?.file?.name;

      const clonedFile = new File([originFile], originFile.name, {
        type: originFile.type,
        lastModified: originFile.lastModified,
      });

      if (handleFileChange) {
        handleFileChange(clonedFile);
      }

      const shouldProcess = format === '*' || (() => {
        const formatArray = format
          ?.split(',')
          .map(ext => ext.trim().replace(/[()]/g, ''));
        return formatArray.some(ext => name.includes(ext));
      })();

      if (shouldProcess) {
        let response;
        if (skipInternalUpload) {
          response = URL.createObjectURL(originFile);
        } else {
          response = await dispatch(uploadFile(originFile, name));
        }

        if (response) {
          let fileObject = {
            name,
            url: response,
            size: info?.file?.size,
            date: new Date().getTime(),
            type: getType,
          };

          if (multiple) {
            setFile(files => [...(files || []), fileObject]);
            if (!skipInternalUpload && setFileURL) {
                setFileURL(fileResponses => [...(fileResponses || []), response]);
            }
          } else {
            setFile([fileObject]);
            if (!skipInternalUpload && setFileURL) {
                setFileURL([response]);
            }
          }

          if (setIsPreviewJD) {
            setIsPreviewJD(true);
          }
        }
      }
    }
  };

  return (
    <Fragment>
      {isDefault && (
        <StyledUpload
          {...props}
          multiple={multiple}
          type="file"
          accept={format}
          customRequest={dummyRequest}
          onChange={onChangeFileUpload}
          beforeUpload={onBeforeUpload}
          disabled={disabled}
        >
          <Wrapper
            isWhiteDesign={isWhiteDesign}
            customHeight={customHeight}
            center
            alignCenter
            column
            pointerEventDisable={pointerEventDisable}
            notAllowedCursor={notAllowedCursor}
          >
            <Flex center width="100%">
              <SmallButtons
                height={'38px'}
                width="38px"
                border={true}
                icon={<UploadIcon />}
                disabled={disabled}
              />
            </Flex>
            <TextWrapper center alignCenter>
              <StyledH2>Browse for file or Drag and drop</StyledH2>
            </TextWrapper>
            <TextWrapper center alignCenter padding={'9px 0px'}>
              <SpanText>Format: {format}</SpanText>
            </TextWrapper>
          </Wrapper>
        </StyledUpload>
      )}
      {showTextUploder && (
        <StyledUpload {...props} type="file" customRequest={dummyRequest}>
          <Control center alignCenter top="5px">
            <AddIcon>
              <Add />
            </AddIcon>
            <UploadText>Upload File</UploadText>
          </Control>
        </StyledUpload>
      )}
      {showButtonUpLoader && (
        <StyledUpload
          {...props}
          multiple={multiple}
          type="file"
          accept={format}
          customRequest={dummyRequest}
          onChange={onChangeFileUpload}
          beforeUpload={onBeforeUpload}
        >
          {showButtonType === 'secondary' ? (
            <Button.Secondary text="Upload another file" width="233px" />
          ) : (
            <Button.Primary text="Change" height={'32px'} />
          )}
        </StyledUpload>
      )}
      {compactMode && (
        <StyledUpload
          {...props}
          multiple={multiple}
          type="file"
          accept={format}
          customRequest={dummyRequest}
          onChange={onChangeFileUpload}
          beforeUpload={onBeforeUpload}
          disabled={disabled}
        >
          <div 
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              cursor: disabled ? 'not-allowed' : 'pointer',
              padding: '8px 12px',
              border: '1px solid #d9d9d9',
              borderRadius: '6px',
              width: 'fit-content',
              transition: 'border-color 0.3s',
            }}
            onMouseEnter={e => {
              if (!disabled) {
                e.currentTarget.style.borderColor = '#40a9ff';
              }
            }}
            onMouseLeave={e => {
              if (!disabled) {
                e.currentTarget.style.borderColor = '#d9d9d9';
              }
            }}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M14.1667 6.66667L10 2.5L5.83333 6.66667" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M10 2.5V12.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span style={{
              fontSize: '14px',
              fontWeight: '500',
            }}>
              Attach a file
            </span>
          </div>
        </StyledUpload>
      )}
    </Fragment>
  );
};

export default Uploader;